import { useQuery } from '@hooks/reactQuery';

import { getHistoryCheckAwtgRanDates } from '@api/hitoryCheck';

import { parseStringDate } from '@utils/date';

import { IAwtgRanDatesResponse } from '@interfaces/cmModule/cmModule';

import { EUserRoles, EVendorsValues } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { HISTORY_CHECK_AWTG_RAN_DATES } from '@constants/queryKeys';

interface UseQueryHistoryCheckAwtgRanDatesParams {
	vendor?: string;
	configType?: string;
	networkElementIds?: string[];
}

export const useQueryHistoryCheckAwtgRanDates = ({
	vendor,
	configType,
	networkElementIds = [],
}: UseQueryHistoryCheckAwtgRanDatesParams) => {
	const {
		data,
		isInitialLoading,
	} = useQuery<IAwtgRanDatesResponse, Date[]>({
		queryKey: [HISTORY_CHECK_AWTG_RAN_DATES, vendor, configType, networkElementIds],
		queryFn: () => getHistoryCheckAwtgRanDates({
			configType: configType!,
			networkElementIds,
		}),
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleViewer,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		select: (res) => res.availableDates?.map((date) => parseStringDate(date)),
		enabled: [
			vendor === EVendorsValues.oran,
			!!configType,
			!!networkElementIds?.length,
		],
		...refetchOptions,
	});

	return {
		dateOptions: data || [],
		isLoading: isInitialLoading,
	};
};
